import { render, staticRenderFns } from "./AlertTrendChart.vue?vue&type=template&id=798619f0"
import script from "./AlertTrendChart.vue?vue&type=script&lang=js"
export * from "./AlertTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports